/* global femcare */

/**
 * Handles global analytics interaction events.
 */
femcare.tracking.analyticsInteractions = {
    /**
     * Initializes global analytics interaction listeners.
     */
    init () {
        this.initSocialShare();
        this.initTrackMyPeriod();
        this.initProductSelection();
        this.initContactLinks();
        this.initOutboundLinks();
        this.initBannerPromotion();
        this.initPromotionInteractions();
        this.initFileDownloads();
    },

    /**
     * Initializes social-share tracking.
     */
    initSocialShare () {
        $('.share-button, .social__link').not('.social--follow .social__link').on('click', (event) => {
            const $element = $(event.currentTarget);
            const channel = $element.data('gaChannel') || $element.data('channel');

            femcare.tracking.analytics.pushEvent('ga4_share', { method: channel });
        });
    },

    /**
     * Initializes period-tracker CTA tracking.
     */
    initTrackMyPeriod () {
        $('#trackMyPeriod').on('click', () => {
            femcare.tracking.analytics.pushEvent('ga4_track_my_period', {
                action_type: 'Click on track my period CTA'
            });
        });
    },

    /**
     * Initializes mouse and keyboard product-selection tracking.
     */
    initProductSelection () {
        $('.cta-panel:not(.cta-panel__article)').on('click keydown', (event) => {
            const isKeyboardSelection = event.type === 'keydown' && event.key === 'Enter';
            const isMouseSelection = event.type === 'click';

            const isInteractiveTarget = event.target.closest('a') || event.target.closest('button');

            if ((!isMouseSelection && !isKeyboardSelection) || isInteractiveTarget) {
                return;
            }

            femcare.tracking.analyticsInteractions.trackProductSelection($(event.target).closest('.cta-panel'));
        });

        $('.cta-panel:not(.cta-panel__article) a').on('click', (event) => {
            event.stopPropagation();
            femcare.tracking.analyticsInteractions.trackProductSelection($(event.target).closest('.cta-panel'));
        });
    },

    /**
     * Tracks a selected product outside search results.
     * @param {jQuery} $panel - Selected product panel.
     */
    trackProductSelection ($panel) {
        if ($panel.parents('.search-results__container').length) {
            return;
        }

        femcare.tracking.product.selectProductAnalytics($panel, $panel.data('ga-event-type') === 'select_item');
    },

    /**
     * Initializes phone and email link tracking.
     */
    initContactLinks () {
        $('a[href^=\'tel:\']').on('click', () => {
            femcare.tracking.analytics.pushEvent('ga4_phone_click');
        });
        $('a[href^=\'mailto:\']').on('click', () => {
            femcare.tracking.analytics.pushEvent('ga4_email_click');
        });
    },

    /**
     * Initializes external-link tracking.
     */
    initOutboundLinks () {
        $('a').not('[href^=\'#\'], [href^=\'mailto:\'], [href^=\'tel:\']').not((index, element) => {
            return element.hostname && element.hostname === location.hostname;
        }).on('click', (event) => {
            const $link = $(event.currentTarget);
            const linkUrl = $link.prop('href');
            if (!linkUrl) {
                return;
            }

            const currentDomain = femcare.shared.util.getCurrentDomain();
            const linkDomain = femcare.shared.util.extractDomain(linkUrl);
            if (linkDomain !== currentDomain) {
                femcare.tracking.analytics.pushEvent('ga4_click', {
                    link_url: linkUrl,
                    link_domain: linkDomain,
                    link_text: $link.text(),
                    outbound: true
                });
            }
        });
    },

    /**
     * Initializes banner promotion tracking.
     */
    initBannerPromotion () {
        $('.banner a.banner__item').on('click', (event) => {
            const $cta = $(event.currentTarget);
            const creativeName = $cta.closest('.banner').data('ga-creative-name');
            const promotionName = $cta.find('.banner__text').text().replace(/\s+/g, ' ').trim();
            const linkUrl = $cta.prop('href');

            if (creativeName && promotionName && linkUrl) {
                femcare.tracking.analytics.pushEvent('ga4_select_promotion', {
                    creative_name: creativeName,
                    promotion_name: promotionName,
                    link_url: linkUrl
                });
            }
        });
    },

    /**
     * Initializes promotion-click tracking.
     */
    initPromotionInteractions () {
        const elements = [
            {
                selector: '.hero-slide a',
                label: 'Hero Banner'
            },
            {
                selector: '.signpost-topic a, .signpost-basic a',
                label: 'Promo box'
            },
            {
                selector: '.signpost-info-item a, .signpost-article a',
                label: 'Article box'
            },
            {
                selector: '.signpost-topic-item a',
                label: 'Banner'
            },
            {
                selector: '.suggested-products__slider a',
                label: 'Recommended article'
            }
        ];

        elements.forEach((element) => {
            $(element.selector).on('click', (event) => {
                const promotionName = $(event.currentTarget).data('ga-promotion-name');
                if (promotionName) {
                    femcare.tracking.analytics.pushEvent('ga4_select_promotion', {
                        creative_name: element.label,
                        promotion_name: promotionName
                    });
                }
            });
        });
    },

    /**
     * Initializes configured file-download tracking.
     */
    initFileDownloads () {
        $('.signpost-topic-item a').on('click', (event) => {
            const $link = $(event.currentTarget);
            const eventName = $link.data('ga-event-type');
            const eventId = $link.data('ga-event-id');

            if (eventName === 'ga4_file_download' && eventId) {
                femcare.tracking.analytics.pushConfiguredEvent(eventId.toString(), eventName, false);
            }
        });
    }
};
